var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-group',{attrs:{"label":_vm.config.label}},[_c('b-input',{attrs:{"placeholder":_vm.config.placeholder},model:{value:(_vm.valueModel),callback:function ($$v) {_vm.valueModel=$$v},expression:"valueModel"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }